export default "__VITE_ASSET__DdJPclF0__"